<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-2/3 md:w-1/3 "
    zIndex="100001"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">
      Tanda Tangan Surat
    </section>
    <div class="w-full p-3 vx-row">
      <div class="w-full vx-col mb-3">
        <vs-input
          class="w-full"
          label="Passprhase"
          type="password"
          v-model="input.passphrase"
        ></vs-input>
      </div>
      <div class="w-full vx-col mb-3">
        <vs-button @click="fillSignature">Tanda Tangan</vs-button>
      </div>
    </div>
  </global-modal>
</template>

<script>
import { digofHttp as axios } from "@/axios";

export default {
  props: ["documentId"],

  data() {
    return {
      uuid: null,
      dialog: {
        isActive: false
      },
      input: {
        passphrase: ""
      }
    };
  },
  methods: {
    toggleActive(isActive, item = null) {
      this.dialog.isActive = isActive;
      if (item) {
        this.uuid = item.uuid;
      }
    },
    async fillSignature() {
      this.$vs.loading();
      if (!this.input.passphrase) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Password kosong !"
        });
        return 0;
      }

      await axios({
        method: "POST",
        url: `signature/${this.uuid}`,
        headers: {
          Authorization: `Bearer ${this.$sanctum.getToken()}`
        },
        data: {
          password: this.input.passphrase
        }
      })
        .then(() => {
          this.$emit("submitCallback");
          this.$vs.notify({
            color: "success",
            title: "Selamat",
            text: "Tanda tangan elektronik berhasil"
          });
          this.toggleActive(false);
        })
        .catch(error => {
          this.$vs.notify({
            color: "danger",
            title: "Terjadi Kesalahan",
            text: error
          });
        });

      this.$vs.loading.close();
    }
  },
  watch: {
    documentId(v) {
      console.log(v);
    }
  }
};
</script>
